import isServer from './isServer';

export default function initPageViewAnalytics(apiClient, getState, history) {
  if (isServer()) return;

  // eslint-disable-next-line global-require
  const createAnalytics = require('../../client/utils/analytics').default;
  const analytics = createAnalytics(apiClient, getState, history);

  history.listen((location) => {
    analytics.sendPageView(location);
  });
}
